import * as React from 'react';
import Helmet from 'react-helmet';
import { Config } from '../../config/index';
import { Link } from 'react-router-dom';
import FittedImage from 'react-fitted-img';
import AgeGateBg from '../../assets/images/age-gate-bg.png';

export default function AgeGateRender({ warning }) {
  return (
    <React.Fragment>
      <Helmet>
        <title>Age Gate</title>
        <link rel="canonical" href={`${Config.FRONT_END_URL}/age-gate`} />
      </Helmet>
      <div className="page page--age-gate">
        <div className="row middle-lg">
          <div className="img-column col-xs-12 col-md-6">
            <FittedImage
              fit='cover'
              className="fitted-img"
              src={AgeGateBg}
              alt="Age Gate"
            />
          </div>

          <div className="content-column col-xs-12 col-md-6">
            <div className="row center-xs">
              <div className="heading col-xs-12">
                <p className="age-gate-title">
                  Welcome to Tabacalera USA
                </p>
              </div>

              <div className="body col-xs-12">
                <p>Are you over <span>21</span>?</p>
                <button className="themed-btn theme-red confirm" onClick={this.confirm}>
                    YES
                </button>
                  <button className="themed-btn theme-dark deny" onClick={this.deny}>
                    NO
                </button>
                {this.isValidatedAgeDefined && !this.validated &&
                  <p className="age-gate-invalid-error">Sorry, you must be at least 21 or older to view this site.</p>}
                <p>
                  By entering out site, you agree to our <Link to="/privacy-policy">Privacy Policy</Link> and <Link to="/terms-of-use">Terms Of Use</Link>.
                </p>
              </div>

              {warning &&
                <div className="footer col-xs-12">
                  <div className="warning-container">
                    <div className="warning">
                      <p>
                        <span className="title">{warning.title}&nbsp;</span>
                        {warning.text}
                      </p>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/containers/AgeGate/render.tsx